export default "__VITE_ASSET__B81vU6VR__"